import React,{ useEffect, useState,useRef} from 'react'

import {
    SearchOutlined,
    EditOutlined,
    ReloadOutlined,
    CheckOutlined,
    CloseOutlined,
    ExclamationCircleOutlined
  } from '@ant-design/icons';
import ImageChecker from '../../components/Generic/ImageChecker'

import { PageHeader, Pagination, Input, Button, Table,Tabs, Spin,Typography,Tag,List,Popconfirm,message } from 'antd';

import moment from 'moment';

import MonthlyAuditTable from '../../components/monthlyAudit/Table';
import AuditItemsTable from '../../components/monthlyAudit/AuditItemsTable';


import AddEditModal from '../../components/Generic/AddEditModal';
import AddMonthlyAuditModal from '../../components/monthlyAudit/AddMonthlyAuditModal';





import {getLocations} from '../../Redux/actions/locationsActions'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {loadMoreMonthlyInventoryData,getLatestAuditofcurrentBranch,approveMonthlyInventory} from '../../Redux/actions/monthlyInventoryActions'


import {voidSale} from '../../Redux/actions/dailysalesActions'

import {setProductInventory} from '../../Redux/actions/inventoryActions'

import './styles.scss';
import './styles.css';

const { TabPane } = Tabs;


const { Search } = Input;
const INITIAL_STATE = {
  searchText: ''
};
const API_URL = 'monthlyaudit';

const PAGENAME = 'Audit';

const MODAL_BLUEPRINT=[

  {
    title: 'Name',
    key: 'name',
    type: 'text',  
  
  },
  {
    title: 'Address',
    key: 'address',
    type: 'text',    
  },
  {
    title: 'phone',
    key: 'contactno',
    type: 'number',     
  },
  {
    title: 'contact person',
    key: 'contact_person',
    type: 'text',    
  },
  {
    title: 'operating hours',
    key: 'operating_hours',
    type: 'text',    
  },

  
]




const Index = (props) => {
    const [loading, setLoading] = useState(false)
    const [mainSearch, setMainSearch] = useState(null)
    const [resetTable, setResetTable] = useState(false)

    const [modalMode, setModalMode] = useState('edit')
    const [currentSelected, setCurrentSelected] = useState(null)


    const [currentlatest, setCurrentLatest] = useState(null)



    const tableRef = useRef();
    const dispatch = useDispatch()  
    const { crudData,crudDataCount,locations,user } = useSelector(
      state => ({
        crudData: state.dailysales.data,
        crudDataCount: state.dailysales.dataCount,
        user: state.auth.user,    
        locations: state.locations.locations  
        
      }),
      shallowEqual
    )
    useEffect(() => {		
      

    }, [])

    useEffect(() => {		
      dispatch(getLocations())
      retrievethelatestaudit()
    }, [])
    
    const retrievethelatestaudit = async() =>{
      var latest = await dispatch(getLatestAuditofcurrentBranch())
      console.log(latest)
      setCurrentLatest(latest)
    };
    
    const onSearch = value =>{
      setMainSearch(value)
    };

    const itemSelected = (value) =>{    
      setModalMode('edit')
      setCurrentSelected(value)

    };


    const createDestinationFilter = () =>{
      if(user){
        var locationsfiltered = [
          {
            text: user.branch_name,
            value:  user.branch_name,
          }
        ]
      }
 
   
      if( user.role == 'admin' || user.role == 'manager'){
        locationsfiltered = locations.map(item =>{
 
          var newloc =  {
            text: item.name,
            value: item.name,
          }
          return(newloc)
        })
      }

      return( locationsfiltered)
    }



    const approveAudit = async (record) =>{
            


      if(!loading){
        setLoading(true)
        message.info('Approving Audit')
    
        var newsold = await dispatch(approveMonthlyInventory(record.id))
        setResetTable(!resetTable)
        setLoading(false)
      }
      
    }
    

    const columns = [
      {
        title: 'Branch',
        dataIndex: 'branch_name',
        key: 'branch_name',  
        filters: createDestinationFilter(),
        onFilter: (value, record) => value.includes(record.branch_name),   
        sorter:  (a, b) => a.branch_name.localeCompare(b.branch_name),
      },
      {
        title: 'Created at',
        dataIndex: 'created_at',
        key: 'created_at',         
        sorter:  (a, b) => a.created_at.localeCompare(b.created_at),
        render: (text, record, index) =>{  

          var pending_existing = false
          record.audited_items.map(record =>{      
            if(record.requested_status == 'pending'){
              pending_existing = true
            }
          })
          return(
            <div className="vertical">
    
              <span> create date: </span>
              <span> {moment(text).format('LLL')} </span>
              <span>{'-----------'}</span>
              <span> {record.created_name}</span>     
              {user.role == 'admin' || user.role == 'manager'?
                <span>{'-----------'}</span>
              :null}     
              {user.role == 'admin' || user.role == 'manager'?
                 record?.checked_at? 
                 <div className="vertical"> 
                    <span> check date: </span>
                    <span> {moment(record.checked_at).format('LLL')} </span>
                    <span> check by: </span>
                    <span> {record.checked_name}</span>     

                 </div>  
                :   
                <div style={{width:'10ch'}}> 
                  {pending_existing ? 
                   <Button type={'warning'} width={'10ch'}>Pending Request</Button>    
                  :

                  <Button type={'primary'} width={'10ch'} loading={loading} onClick={()=>{approveAudit(record)}}>Approve</Button>    
                  }     
                </div>  
      
              :null}    
            </div>
          )
        }
      },
      {
        title: 'Inventory Count',
    
        render: (text, record, index) =>{  
           
          return(
            <AuditItemsTable thisrecord={record} currentlatest={currentlatest}
            onModalClose={(action)=>{
              if(action == 'reset'){
                setResetTable(!resetTable)
              }
        
            }}
            
            />
            
          )
        }
    
      },
  
    ]




    return(
      <div className="maindiv">
            <div className={"generic_container"}>
                <PageHeader
                title={PAGENAME+'s'}
                subTitle={
                  <div className={"dailysales_header"}>
               
                    {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
                
                  </div>
                }
                extra={
                    <div className={"dailysales_header"}>
              
                      {currentlatest?.checked_at || currentlatest == 'none' ? 
                        <AddMonthlyAuditModal onModalClose={()=>{setResetTable(!resetTable)}} />
                        :
                     
                        <Tag>Latest Audit has not been checked yet</Tag>
      
                      }
                      {crudDataCount > 0? 
                     
                        <Button type={"primary"} shape={"round"} 
                        onClick={()=>{
               
                            dispatch(loadMoreMonthlyInventoryData())
                          
                        
                        }} 
                        style={{marginRight:'1em'}}>Load More</Button>
                      :null}
                      
                      <Button onClick={()=>{setResetTable(!resetTable)}} className="button"><ReloadOutlined /></Button>
                     
                    </div>  
                }
                >

                    
      
                </PageHeader>
                <div className={"content_container"}>
                 
                    <MonthlyAuditTable 
                        // ref={tableRef} 
                        apiurl={API_URL}
                        columns={columns}
                        mainSearch={mainSearch}
                        resetTable={resetTable}
                        ChangedSelected={(selected)=>{itemSelected(selected)}}
                        rowClick={(selected)=>{itemSelected(selected)}}
        
                    />
                
                </div>

            </div>
        </div>
    )
}

export default Index